import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import AppSwitcher from "../components/AppSwitcher";
import "./Home.css";

const APPLE_STORE_URL = "https://apps.apple.com/kr/app/%EA%B8%88%EB%9A%9D%EB%94%B1-%EA%B8%88%EC%BA%90%EA%B8%B0-%EB%A6%AC%EC%9B%8C%EB%93%9C-%EC%95%B1%ED%85%8C%ED%81%AC-%EB%8F%88%EB%B2%84%EB%8A%94%EC%95%B1-%EA%B8%88%ED%85%8C%ED%81%AC/id6748942265";
const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.goldttak.goldttak_app";

/** 카드 순서별 이미지 URL 배열. 이미지 URL만 넣으면 페이드 슬라이드로 재생됩니다. */
const FEATURE_IMAGES = [
  ["https://olzoom-image.s3.ap-northeast-2.amazonaws.com/2026/02/11/2/f8ddb797-21e5-445d-b8e3-47e6f76e2f46.png", "https://olzoom-image.s3.ap-northeast-2.amazonaws.com/2026/02/11/2/ebf49776-bf3b-4b16-abeb-050e1e3e57d6.png","https://olzoom-image.s3.ap-northeast-2.amazonaws.com/2026/02/11/2/ae225a30-e53f-4e58-bb3a-379f02434d50.png"], // 0: 친구 초대 — 예: ["https://example.com/1.png", "https://example.com/2.png"]
  ["https://goldttak-image.s3.ap-northeast-2.amazonaws.com/2026/02/12/2/103205d7-2067-43ca-88ef-7aba7b85e619.png", "https://goldttak-image.s3.ap-northeast-2.amazonaws.com/2026/02/12/2/3118dc6b-d3c6-408f-993f-a244b34f7223.png","https://goldttak-image.s3.ap-northeast-2.amazonaws.com/2026/02/12/2/e84f5cfa-dadc-434c-98e2-69363858f88a.png"], // 1: 보물상자/룰렛
  ["https://olzoom-image.s3.ap-northeast-2.amazonaws.com/2026/02/11/2/b248d1bd-5a39-4f68-995c-a8f2d10fb180.png", "https://olzoom-image.s3.ap-northeast-2.amazonaws.com/2026/02/11/2/bc221df1-2462-4d3c-9e8e-a235c781286e.png"], // 2: 기프티콘/금
];

const FADE_INTERVAL_MS = 3350;

function Home() {
  const [selectedFeatureIndex, setSelectedFeatureIndex] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const images = selectedFeatureIndex !== null ? FEATURE_IMAGES[selectedFeatureIndex] || [] : [];

  useEffect(() => {
    if (images.length <= 1) return;
    const id = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % images.length);
    }, FADE_INTERVAL_MS);
    return () => clearInterval(id);
  }, [selectedFeatureIndex, images.length]);

  useEffect(() => {
    setCurrentImageIndex(0);
  }, [selectedFeatureIndex]);
  return (
    <div className="home">
      <header className="home-header">
        <div className="header-inner">
          <Link to="/" className="logo-link">
            <img
              src="https://static.wixstatic.com/media/0780aa_06271f0c82c44e639f57cb2504b9aaab~mv2.png/v1/fill/w_70,h_70,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/1024_1024_%EC%98%A4%EB%A6%AC%EC%A7%80%EB%84%90%20%EC%95%B1%20%EC%95%84%EC%9D%B4%EC%BD%98.png"
              alt="금뚝딱 앱 아이콘"
              className="header-logo"
            />
            <span className="header-title">금뚝딱 - 8만명이 선택한 금채굴앱</span>
          </Link>
          <div className="header-sns">
            <AppSwitcher />
            <a href="https://pf.kakao.com/_qczmn" target="_blank" rel="noreferrer noopener" className="header-kakao-btn">카카오톡 문의</a>
            <a href="https://www.youtube.com/@%EA%B8%88%EB%9A%9D%EB%94%B1365" target="_blank" rel="noreferrer noopener" aria-label="YouTube">
              <img src="https://static.wixstatic.com/media/e9bb463a1bc4434c9d33b81b1fe937f5.png/v1/fill/w_40,h_40,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/e9bb463a1bc4434c9d33b81b1fe937f5.png" alt="YouTube" />
            </a>
          </div>
        </div>
      </header>

      <main className="home-main">
        <section className="hero">
          <div className="hero-bg" />
          <div className="hero-content">
            <img
              src="/favicon.png"
              alt="금뚝딱 로고"
              className="hero-logo"
            />
            <h1 className="hero-title">
              실제 순금 채굴앱<br /> <span>금뚝딱</span>
            </h1>
            <p className="hero-tagline">방치만 해도 금이 쌓인다 ✨</p>
            <div className="hero-buttons">
              <a href={APPLE_STORE_URL} target="_blank" rel="noreferrer noopener" className="store-btn">
                <img src="https://static.wixstatic.com/media/c837a6_f118d3e42dd44391bb680dbf64fd9979~mv2.png/v1/fill/w_151,h_52,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Apple%20Store.png" alt="앱 스토어에서 다운로드" />
              </a>
              <a href={GOOGLE_PLAY_URL} target="_blank" rel="noreferrer noopener" className="store-btn">
                <img src="https://static.wixstatic.com/media/c837a6_a8def159231d4dd6b5ca0c31ac29e2fc~mv2.png/v1/fill/w_171,h_52,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Google%20Play.png" alt="Google Play에서 다운로드" />
              </a>
            </div>
          </div>
        </section>

        <section className="features">
          <h2 className="section-title">다양한 혜택</h2>
          <p className="section-subtitle">금 캐는 속도를 올려보세요</p>
          <div className="features-grid">
            <div className={`feature-card ${selectedFeatureIndex === 0 ? "selected" : ""}`} onClick={() => setSelectedFeatureIndex(0)} role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && setSelectedFeatureIndex(0)}>
              <span className="feature-icon"><img src="https://olzoom-image.s3.ap-northeast-2.amazonaws.com/2026/02/11/2/a07d97f7-dfa5-4425-a09b-d3424ea0372d.png" alt="친구 초대시 3가지 혜택" width="150" height="100"/></span>
              <p>친구 초대시 엄청난 혜택!</p>
            </div>
            <div className={`feature-card ${selectedFeatureIndex === 1 ? "selected" : ""}`} onClick={() => setSelectedFeatureIndex(1)} role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && setSelectedFeatureIndex(1)}>
              <span className="feature-icon"><img src="https://olzoom-image.s3.ap-northeast-2.amazonaws.com/2026/02/11/2/d3d0561f-3651-43e9-86b3-8ef4658960a5.png" alt="다양한 보물상자 지급" width="200" height="100"/></span>
              <p>보물상자, 룰렛으로 다양한 재미 요소!</p>
            </div>
            <div className={`feature-card ${selectedFeatureIndex === 2 ? "selected" : ""}`} onClick={() => setSelectedFeatureIndex(2)} role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && setSelectedFeatureIndex(2)}>
              <span className="feature-icon"><img src="https://olzoom-image.s3.ap-northeast-2.amazonaws.com/2026/02/11/2/f86ebd70-2235-4f53-bcb8-91dc7ab3f760.png" alt="기프티콘과 실제 금을 교환" width="180" height="100"/></span>
              <p>기프티콘과 금을 얻어보세요!</p>
            </div>
          </div>
          <div className="features-video-area" aria-live="polite">
            {selectedFeatureIndex !== null && images.length > 0 ? (
              <div className="feature-fade-slide">
                {images.map((src, i) => (
                  <img
                    key={i}
                    src={src}
                    alt=""
                    className="feature-fade-image"
                    style={{ opacity: i === currentImageIndex ? 1 : 0 }}
                  />
                ))}
              </div>
            ) : selectedFeatureIndex !== null ? (
              <p className="features-video-placeholder">이미지 URL을 FEATURE_IMAGES에 추가해 주세요. (예: [&quot;https://...&quot;, &quot;https://...&quot;])</p>
            ) : null}
          </div>
        </section>

        <section className="cta">
          <div className="cta-bg" />
          <div className="cta-content">
            <p className="cta-subtitle">무료로 플레이하세요</p>
            <h2 className="cta-title">금뚝딱 앱 플레이</h2>
            <div className="cta-buttons">
              <a href={APPLE_STORE_URL} target="_blank" rel="noreferrer noopener" className="store-btn">
                <img src="https://static.wixstatic.com/media/c837a6_f118d3e42dd44391bb680dbf64fd9979~mv2.png/v1/fill/w_120,h_40,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Apple%20Store.png" alt="앱 스토어" />
              </a>
              <a href={GOOGLE_PLAY_URL} target="_blank" rel="noreferrer noopener" className="store-btn">
                <img src="https://static.wixstatic.com/media/c837a6_a8def159231d4dd6b5ca0c31ac29e2fc~mv2.png/v1/fill/w_130,h_40,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Google%20Play.png" alt="Google Play" />
              </a>
            </div>
          </div>
        </section>
      </main>

      <footer className="home-footer">
        <div className="footer-inner">
          <div className="footer-brand">
            <img
              src="/favicon.png"
              alt="금뚝딱"
              className="footer-logo"
            />
            <p className="footer-company">주식회사 셀링</p>
            <p className="footer-address">
              화성시 동탄대로21길 10 1512-에이18호(더피스트타워)<br />
              215-88-01706 | 대표 이지훈
            </p>
            <p className="footer-tel">031-221-9719</p>
          </div>
          <div className="footer-links">
            <a href="https://printer3248.wixsite.com/my-site-3" target="_blank" rel="noreferrer noopener">홈</a>
            <a href="https://printer3248.wixsite.com/my-site-3/개인정보-취급방침" target="_blank" rel="noreferrer noopener">개인정보 취급방침</a>
            <a href="https://printer3248.wixsite.com/my-site-3/이용약관" target="_blank" rel="noreferrer noopener">이용약관</a>
          </div>
        </div>
        <p className="footer-copy">© 2024 주식회사 셀링. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default Home;
